module.exports = __webpack_public_path__ + "img/STEP5.42a35771.png";